import * as React from "react";
import { useState, useEffect, useCallback, useRef } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik, Field, Form, ErrorMessage } from "formik";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Button, TextField, FormHelperText } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import ModalSelectCover from "./ModalSelectCover"
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { AutoComplete } from "antd";
import { SuggestedMovies } from "../../../utils/utilsFunctions"
import ProgressBar from "./ProgressBar"
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
// import SelectSubtitles from "./SelectSubtitles";
import { uploadSubtitle } from "../../../../../validations/subtitlesFromValidation";
import { UploadSubtitlesApi, createNewGroupIdApi, uploadCoverApi } from "../../../../../services/subtitlesApi";
import ErrorIcon from '@mui/icons-material/Error';
import MainContext from "../../../../../context/mainContext";
import Chip from '@mui/material/Chip';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IconButton from '@mui/material/IconButton';
import PostAddIcon from '@mui/icons-material/PostAdd';
import LinearWithValueLabel from "./LinearWithValueLabel"
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ReplayIcon from '@mui/icons-material/Replay';
import DeleteAlert from "./DeleteAlert"
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dropzone from 'react-dropzone'
const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function UploadsSubtitles(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [modalSelectCover, setModalSelectCover] = useState(false);
  const [groupId, setGroupId] = useState(false);
  const [season, setSeason] = useState("");
  const [episode, setEpisode] = useState("");
  const [productionYear, setProductionYear] = useState("");
  const [coverUrl, setCoverUrl] = useState(false);
  const [allSubtitles, setAllSubtitles] = useState([{ srtFile: false, srtFileName: "", oneTag: "", otherTags: [], enable: true, language: "", uploadPercent: 0, subtitileCode: false }]);
  const [lastMovieName, setLastMovieName] = useState("");
  const [nameOfMovie, setNameOfMovie] = useState("");
  const [typeOfVideo, setTypeOfVideo] = useState("movie");
  const [autocompleteValue, setAutocompleteValue] = React.useState(null);
  const [deleteAlert, setDeleteAlert] = React.useState({ open: false, subIndex: null });
  const [coverUploadPercent, setCoverUploadPercent] = useState(0);
  const [autoGetCoverFile, setAutoGetCoverFile] = useState(false);
  const submitEndRef = useRef(null)

  const scrollToBottom = () => {
    submitEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  const handleSubtitlesData = (action, indexSub, srtFile, value, changeLanguage) => {
    const cpAllSubtitles = [...allSubtitles]
    if (isNaN(indexSub)) {
    } else if (action == "srtFile") {
      if (srtFile) {
        cpAllSubtitles[indexSub]["srtFile"] = srtFile
        cpAllSubtitles[indexSub]["srtFileName"] = srtFile.name
        let tagList = ['1080p', '720p', "dd5", "aac", '360p', '480p', 'web-dl', 'web_dl', 'h264', 'h265', 'bluray', 'dvdrip', 'hdtv', 'hevc', '2160p', 'dts-hd', 'dvb', 'cam', 'webdl', 'dvd', 'dts-hd', "webrip", "web-rip", "x265", "x264",]
        let filmName = srtFile.name.toLowerCase()
        const otherTags = tagList.filter((tag) => filmName.indexOf(tag) >= 0 && !cpAllSubtitles[indexSub]["otherTags"].includes(tag))
        cpAllSubtitles[indexSub]["otherTags"] = [...cpAllSubtitles[indexSub]["otherTags"], ...otherTags]
        setAllSubtitles(cpAllSubtitles)
      }
      else console.log("select file")
    } else if (action == "addEnSub") {
      cpAllSubtitles.push({ srtFile: false, oneTag: "", otherTags: [], enable: true, language: "en", uploadPercent: 0, subtitileCode: false })
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "addFaSub") {
      cpAllSubtitles.push({ srtFile: false, oneTag: "", otherTags: [], enable: true, language: "fa", uploadPercent: 0, subtitileCode: false })
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "addNoLangSub") {
      cpAllSubtitles.push({ srtFile: false, oneTag: "", otherTags: [], enable: true, language: "", uploadPercent: 0, subtitileCode: false })
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "deleteSub") {
      cpAllSubtitles.splice(value, 1);
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "oneTagValue") {
      cpAllSubtitles[indexSub]["oneTag"] = value
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "changeUploadPercent") {
      cpAllSubtitles[indexSub]["uploadPercent"] = value
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "setSubtitileCode") {
      cpAllSubtitles[indexSub]["subtitileCode"] = value
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "changeLanguage") {
      cpAllSubtitles[indexSub]["language"] = changeLanguage
      setAllSubtitles(cpAllSubtitles)
    } else if (action == "addTag") {
      if (cpAllSubtitles[indexSub]["oneTag"].length > 0) {
        cpAllSubtitles[indexSub]["otherTags"].push(cpAllSubtitles[indexSub]["oneTag"])
        cpAllSubtitles[indexSub]["oneTag"] = ""
        setAllSubtitles(cpAllSubtitles)
      }
    } else if (action == "deleteTag") {
      let cpSubTags = cpAllSubtitles[indexSub]["otherTags"]
      cpSubTags.splice(cpSubTags.indexOf(value), 1);
      cpAllSubtitles[indexSub]["otherTags"] = cpSubTags
      setAllSubtitles(cpAllSubtitles)
    }
  }


  const handleModalSelectCover = (coverFile) => {
    if (!autocompleteValue) {
      customToastify("error", "لطفا ابتدا نام فیلم را وارد کنید")
    } else {
      if (coverFile) {
        setCoverUrl(coverFile)
      }
      setModalSelectCover(!modalSelectCover)
    }
  }

  const handlecoverUploadPercent = (percent) => {
    setCoverUploadPercent(percent * 100)
  }

  const handleCoverUpload = async (coverFile) => {
    if (!autocompleteValue) {
      customToastify("error", "لطفا ابتدا نام فیلم را وارد کنید")
    } else {
      try {
        let formData = new FormData();
        formData.append("coverFile", coverFile);
        formData.append("nameOfMovie", nameOfMovie);
        let response = await uploadCoverApi(formData, handlecoverUploadPercent);;
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setCoverUrl(`${SERVER_URL}/subtitles/covers/${resData["data"]["data"][0]["fileName"]}`)
          setCoverUploadPercent(0)
          return `${SERVER_URL}/subtitles/covers/${resData["data"]["data"][0]["fileName"]}`
        } else {
          setCoverUploadPercent(0)
          return false
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        console.error(error);
        setCoverUploadPercent(0)
        return false
      }
    }

  }

  const handleDeleteAlert = (action, subindex) => {
    if (action == "open") {
      setDeleteAlert({ open: true, subIndex: subindex })
    } else if (action == "close") {
      setDeleteAlert({ open: false, subIndex: null })
    } else if (action == "deleteSub") {
      const cp = { ...deleteAlert }
      handleSubtitlesData("deleteSub", 0, false, cp["subIndex"], false)
      setDeleteAlert({ open: false, subIndex: null })
    }
  }
  const handleSubtitleUploadPercent = (percent, indexSub) => {
    handleSubtitlesData("changeUploadPercent", indexSub, false, percent * 100, false)
  }

  const allSubtitlesUpload = async (withCover) => {
    try {
      let uploadCover = false
      if (withCover) {
        if (!coverUrl && autoGetCoverFile) uploadCover = await handleCoverUpload(autoGetCoverFile)
        else uploadCover = true
      }
      allSubtitles.forEach((sub, idx) => {
        setTimeout(() => { UploadSubtitlesApiRun(idx, uploadCover) }, 250 * idx)
      })
    } catch (error) {
      console.error(error)
    }
  }

  const UploadSubtitlesApiRun = async (indexSub, newCoverUrl) => {
    if (allSubtitles[indexSub]["uploadPercent"] == 100) customToastify("error", `زیرنویس ${indexSub} قبلا آپلود شده است`)
    else {
      let subtitles = allSubtitles[indexSub]["srtFile"]
      let subtitlesLanguage = allSubtitles[indexSub]["language"]
      let otherTags = allSubtitles[indexSub]["otherTags"]
      let uploadType = "userUpload"
      let finalCoverUrl = false
      if (newCoverUrl) finalCoverUrl = newCoverUrl
      else finalCoverUrl = coverUrl
      if (!subtitles) customToastify("error", "لطفا زیرنویس را انتخاب کنید")
      else if (!nameOfMovie) customToastify("error", "لطفا نام فیلم را وارد کنید")
      else if (!subtitlesLanguage) customToastify("error", "لطفا زبان زیرنویس را انتخاب کنید")
      else if (typeOfVideo == "Serial" && (!season || !episode)) customToastify("error", "لطفا شماره فصل و قسمت را وارد کنید")
      else if (!finalCoverUrl) customToastify("error", "لطفا کاور زیرنویس را انتخاب کنید")
      else {
        try {
          let formData = new FormData();
          formData.append("subtitles", subtitles);
          formData.append("uploadType", uploadType);
          otherTags.forEach(item => {
            formData.append(`otherTags`, item);
          });
          formData.append("subtitlesLanguage", subtitlesLanguage);
          formData.append("nameOfMovie", nameOfMovie);
          formData.append("coverUrl", finalCoverUrl);
          formData.append("groupId", groupId);
          formData.append("productionYear", productionYear);
          if (typeOfVideo == "Serial") {
            formData.append("season", season);
            formData.append("episode", episode);
          }
          const response = await UploadSubtitlesApi(formData, handleSubtitleUploadPercent, indexSub);
          const resData = checkResponseData(response);
          if (resData["success"]) {
            let code = resData["data"]["data"][0]["subtitlesUploadId"]
            handleSubtitlesData("setSubtitileCode", indexSub, false, code, false)
            setLastMovieName(nameOfMovie)
          } else {
            console.log("problem in UploadSubtitles")
            handleSubtitlesData("changeUploadPercent", indexSub, false, 101, false)
          }
        } catch (error) {
          handleSubtitlesData("changeUploadPercent", indexSub, false, 101, false)
          const errData = checkErrorMessage(error);
          let errMsg = errData["titles"] || errData["message"]
          customToastify("info", errMsg || "مشکلی وجود دارد");
          console.error(error);
        }
      }
    }
  };



  const resetValueForm = () => {
    setAllSubtitles([{ srtFile: false, srtFileName: "", oneTag: "", otherTags: [], enable: true, language: "", uploadPercent: 0, subtitileCode: false }]);
    setCoverUrl(false)
    setNameOfMovie("")
    setTypeOfVideo("movie")
    setSeason("")
    setEpisode("")
    setProductionYear("")
    setAutocompleteValue(null)
    getNewGroupId()
    setCoverUploadPercent(0)
    setAutoGetCoverFile(false)
  }
  const handleMultiUpload = (files, language, index) => {
    let lang = language
    const cpAllSubtitles = [...allSubtitles]
    let subLength = files.length
    cpAllSubtitles.splice(index, 1);
    let num = 0
    let getMovieName = true
    let getProductionYear = true
    for (let i in files) {
      let filmName = files[i]["name"].toLowerCase()
      let filePath = files[i]["path"].toLowerCase()
      let splitPath = filePath.split("/")
      let suffix = filmName.slice(filmName.length - 3, filmName.length)
      let coverSuffix = ["ebp", "jpg", "png", "gif", "peg", "bmp", "iff"]
      if (splitPath[1] && splitPath[1].slice(0, 3) == "0 (") {
        if (splitPath.length == 3 && coverSuffix.includes(suffix)) setAutoGetCoverFile(files[i])
        if (splitPath.length == 5) {
          let movieName = splitPath[2]
          if (getMovieName) {
            getMovieName = false
            setAutocompleteValue(movieName);
            setNameOfMovie(movieName)
          }
          if (getProductionYear) {
            getProductionYear = false
            let year = parseInt(movieName.substr(movieName.length - 4))
            if (!isNaN(year) && year > 1800) setProductionYear(year)
          }
          if (splitPath[3] == "english") lang = "en"
          else if (splitPath[3] == "persian") lang = "fa"
        } else if (splitPath.length == 4) {
          let folderName = splitPath[2]
          let splitForDetails = folderName.split("-")
          if (splitForDetails.length >= 2 && splitForDetails[0].slice(0, 2) == "en") {
            lang = "en"
          } else {
            let movieName2 = splitPath[2]
            if (getMovieName) {
              getMovieName = false
              setAutocompleteValue(movieName2);
              setNameOfMovie(movieName2)
            }
            if (getProductionYear) {
              getProductionYear = false
              let year = parseInt(movieName2.substr(movieName2.length - 4))
              if (!isNaN(year) && year > 1800) setProductionYear(year)
            }
            if (splitPath[1] == "english") {
              setAutocompleteValue("");
              setNameOfMovie("")
              lang = "en"
            }
            else if (splitPath[1] == "persian") {
              setAutocompleteValue("");
              setNameOfMovie("")
              lang = "fa"
            }
            else lang = "fa"
          }
        }
      } else {
        if (splitPath.length == 1 && coverSuffix.includes(suffix)) setAutoGetCoverFile(files[i])
        if (splitPath.length == 4) {
          let movieName = splitPath[1]
          if (getMovieName) {
            getMovieName = false
            setAutocompleteValue(movieName);
            setNameOfMovie(movieName)
          }
          if (getProductionYear) {
            getProductionYear = false
            let year = parseInt(movieName.substr(movieName.length - 4))
            if (!isNaN(year) && year > 1800) setProductionYear(year)
          }
          if (splitPath[2] == "english") lang = "en"
          else if (splitPath[2] == "persian") lang = "fa"
        } else if (splitPath.length == 3) {
          let folderName = splitPath[1]
          let splitForDetails = folderName.split("-")
          if (splitForDetails.length >= 2 && splitForDetails[0].slice(0, 2) == "en") {
            lang = "en"
          } else {
            let movieName2 = splitPath[1]
            if (getMovieName) {
              getMovieName = false
              setAutocompleteValue(movieName2);
              setNameOfMovie(movieName2)
            }
            if (getProductionYear) {
              getProductionYear = false
              let year = parseInt(movieName2.substr(movieName2.length - 4))
              if (!isNaN(year) && year > 1800) setProductionYear(year)
            }
            if (splitPath[1] == "english") {
              setAutocompleteValue("");
              setNameOfMovie("")
              lang = "en"
            }
            else if (splitPath[1] == "persian") {
              setAutocompleteValue("");
              setNameOfMovie("")
              lang = "fa"
            }
            else lang = "fa"
          }
        }
      }

      if (subLength > num) {
        num++
        if (suffix == "srt") {
          let tagList = ['1080p', '720p', "dd5", "aac", '360p', '480p', 'web-dl', 'web_dl', 'h264', 'h265', 'bluray', 'dvdrip', 'hdtv', 'hevc', '2160p', 'dts-hd', 'dvb', 'cam', 'webdl', 'dvd', 'dts-hd', "webrip", "web-rip", "x265", "x264",]
          const otherTags = tagList.filter((tag) => filmName.indexOf(tag) >= 0)
          cpAllSubtitles.push({ srtFile: files[i], srtFileName: files[i]["name"], oneTag: "", otherTags, enable: true, language: lang, uploadPercent: 0, subtitileCode: false })
        }
      }
    }
    setAllSubtitles(cpAllSubtitles)
    setTimeout(() => {
      scrollToBottom()
    }, 200);
  }
  const getNewGroupId = async () => {
    let response = await createNewGroupIdApi({})
    const resData = checkResponseData(response);
    if (resData["success"]) setGroupId(resData["data"]["data"][0]["groupId"])
  }
  useEffect(() => {
    getNewGroupId()
  }, [])
  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <DeleteAlert deleteAlert={deleteAlert} handleDeleteAlert={handleDeleteAlert} />
        <Paper sx={{ textAlign: "center" }}>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                  >
                    {" "}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    نام آپلود آخر:
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Typography>
                      {lastMovieName}
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"نوع فیلم"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <FormControl
                      component="fieldset"
                      sx={{
                        mx: 1,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <RadioGroup
                        onClick={(e) => {
                          setTypeOfVideo(e.target.value);
                        }}
                        aria-label="videoType"
                        value={typeOfVideo}
                        name={"videoType"}
                        sx={{ display: "flex", flexDirection: "row" }}
                      >
                        <FormControlLabel
                          value="movie"
                          control={<Radio />}
                          label="فیلم"
                        />
                        <FormControlLabel
                          value="Serial"
                          control={<Radio />}
                          label="سریال"
                        />
                        <FormControlLabel
                          value="clip"
                          control={<Radio />}
                          label="کلیپ"
                        />
                      </RadioGroup>
                    </FormControl>
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"نام فیلم"}
                  </StyledTableCell>

                  <StyledTableCell align="left">
                    <AutoComplete
                      style={{
                        width: 213,
                        margin: 9,
                      }}
                      id="nameOfMovie"
                      value={autocompleteValue}
                      options={(autocompleteValue && autocompleteValue.length >= 2) ? SuggestedMovies : []}
                      disabled={typeOfVideo == ""}
                      placeholder="نام فیلم یا سریال"
                      filterOption={(inputValue, option) =>
                        option.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      popupClassName="classes.container"
                      onChange={(value) => {
                        setAutocompleteValue(value);
                        setNameOfMovie(value)
                      }}
                    />
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"شماره فصل"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TextField
                      sx={{ minWidth: 200 }}
                      size="small"
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 500 } }}
                      name="season"
                      value={season}
                      disabled={typeOfVideo !== "Serial"}
                      label="فصل"
                      placeholder="فصل"
                      onChange={(e) => { setSeason(e.target.value) }}
                    />
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"شماره قسمت"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TextField
                      sx={{ minWidth: 200 }}
                      size="small"
                      type="number"
                      disabled={typeOfVideo !== "Serial"}
                      InputProps={{ inputProps: { min: 0, max: 5000 } }}
                      value={episode}
                      name="episode"
                      label="قسمت"
                      placeholder="قسمت"
                      onChange={(e) => { setEpisode(e.target.value) }}
                    />
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell onClick={() => {
                    let year = parseInt(nameOfMovie.substr(nameOfMovie.length - 4))
                    if (!isNaN(year) && year > 1900) setProductionYear(year)
                  }} component="th" scope="row">
                    {"سال ساخت"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TextField
                      sx={{ minWidth: 200 }}
                      size="small"
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 5000 } }}
                      value={productionYear}
                      name="productionYear"
                      label="سال ساخت"
                      placeholder="سال ساخت"
                      onChange={(e) => { setProductionYear(e.target.value) }}
                    />
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"کاور(عکس) فیلم"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Button onClick={() => { handleModalSelectCover(false) }}>
                      انتخاب کاور
                    </Button>
                    <Typography onClick={() => { navigator.clipboard.writeText(coverUrl) }}>
                      {coverUrl}
                    </Typography>
                    <ModalSelectCover nameOfMovie={nameOfMovie} handleModalSelectCover={handleModalSelectCover} modalSelectCover={modalSelectCover} />
                  </StyledTableCell>
                </StyledTableRow>

                {allSubtitles.map((sub, index) => (
                  <StyledTableRow key={`sub-${index}`}>
                    <StyledTableCell component="th" scope="row">
                      {sub["uploadPercent"] == 0 || sub["uploadPercent"] == 101 ? <Button
                        sx={{ m: 0.5 }}
                        variant="contained"
                        startIcon={<DeleteIcon />}
                        size="small"
                        color="error"
                        onClick={() => { handleDeleteAlert("open", index) }}
                      >
                        حذف سطر
                      </Button> : null}
                      {sub["uploadPercent"] > 0 && sub["uploadPercent"] < 101 ? null : sub["uploadPercent"] == 101 ? <Button
                        sx={{ m: 0.5 }}
                        variant="contained"
                        startIcon={<ReplayIcon />}
                        size="small"
                        color="success"
                        onClick={() => { UploadSubtitlesApiRun(index) }}
                      >
                        تلاش دوباره
                      </Button> : <Button
                        sx={{ m: 0.5 }}
                        variant="contained"
                        startIcon={<UploadFileIcon />}
                        size="small"
                        color="success"
                        onClick={() => { UploadSubtitlesApiRun(index) }}
                      >
                        آپلود
                      </Button>}
                      {sub["uploadPercent"] == 100 && !sub["subtitileCode"] ? <Typography sx={{ color: "#b402b5" }}>لطفا صبر کنید</Typography> : sub["uploadPercent"] == 100 && sub["subtitileCode"] ? <Button
                        sx={{ m: 0.5 }}
                        startIcon={<ContentCopyIcon />}
                        size="small"
                        color="success"
                        onClick={() => { navigator.clipboard.writeText(sub["subtitileCode"]) }}
                      >
                        {sub["subtitileCode"]}
                      </Button> : null}


                      <br />
                      {sub["uploadPercent"] > 0 && sub["uploadPercent"] < 101 ? <LinearWithValueLabel progress={sub["uploadPercent"]} /> : sub["uploadPercent"] == 101 ? <LinkOffIcon color="error" sx={{ position: "relative", right: "37%" }} /> : null}

                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Dropzone onDrop={acceptedFiles => handleMultiUpload(acceptedFiles, sub["language"], index)}>
                        {({ getRootProps, getInputProps }) => (
                          <section>
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <p style={{ border: "solid 2px", padding: "5px" }}>زیرنویس ها را درگ و دراپ کنید</p>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      <span>
                        {sub["srtFileName"]}
                      </span>
                      <hr style={{ margin: "5px" }} />
                      <FormControl style={{ minWidth: 170 }}>
                        <InputLabel id="demo-simple-select-label">
                          زبان زیرنویس
                        </InputLabel>
                        <Select
                          size="small"
                          label="subtitlesLanguage"
                          value={sub["language"]}
                          onChange={(e) => {
                            handleSubtitlesData("changeLanguage", index, false, false, e.target.value)
                          }}
                        >
                          <MenuItem key={0} value={"fa"}>
                            Persian
                          </MenuItem>
                          <MenuItem autoFocus key={1} value="en">
                            English
                          </MenuItem>
                          <MenuItem autoFocus key={2} value="de">
                            German
                          </MenuItem>
                          <MenuItem autoFocus key={3} value="it">
                            Italian
                          </MenuItem>
                          <MenuItem autoFocus key={4} value="fr">
                            French
                          </MenuItem>
                          {/* {Object.keys(languagesList).map((option, index) => (
                            <MenuItem key={index + 2} value={option}>
                              {languagesList[option]}
                            </MenuItem>
                          ))} */}
                        </Select>
                      </FormControl>
                      <TextField
                        type="text"
                        size="small"
                        name="tags"
                        placeholder="برچسب مرتبط"
                        value={sub["oneTag"]}
                        onChange={(e) => {
                          handleSubtitlesData("oneTagValue", index, false, e.target.value, false)
                        }}
                      />
                      <IconButton aria-label="delete" color="primary" onClick={() => handleSubtitlesData("addTag", index, false, false, false)}>
                        <AddBoxIcon />
                      </IconButton>
                      {sub["otherTags"].map((tag, idx) => <Chip key={`tag-${idx}`} label={tag}
                        deleteIcon={<DeleteIcon />}
                        onDelete={() => { handleSubtitlesData("deleteTag", index, false, tag, false) }}
                      />
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}


                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"آپلود کاور"}
                    {coverUploadPercent > 0 && coverUploadPercent < 101 ? <LinearWithValueLabel progress={coverUploadPercent} /> : coverUploadPercent == 101 ? <LinkOffIcon color="error" sx={{ position: "relative", right: "37%" }} /> : coverUrl ? <Typography sx={{ color: "green" }}>{coverUrl.slice(coverUrl.length - 20, coverUrl.length)}</Typography> : null}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Dropzone onDrop={acceptedFiles => {
                      handleCoverUpload(acceptedFiles["0"])
                    }}>
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <p>یک عکس دراپ کنید</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    <Typography onClick={() => { navigator.clipboard.writeText(coverUrl) }}>

                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"سطر جدید"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Button
                      variant="contained"
                      startIcon={<PostAddIcon />}
                      sx={{ m: 1 }}
                      size="small"
                      color="info"
                      onClick={() => { handleSubtitlesData("addEnSub", 0, false, false, false) }}
                    >
                      en
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<PostAddIcon />}
                      sx={{ m: 1 }}
                      size="small"
                      color="info"
                      onClick={() => { handleSubtitlesData("addFaSub", 0, false, false, false) }}
                    >
                      fa
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<PostAddIcon />}
                      sx={{ m: 1 }}
                      size="small"
                      color="info"
                      onClick={() => { handleSubtitlesData("addNoLangSub", 0, false, false, false) }}
                    >
                      بدون زبان
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "space-between" }} ref={submitEndRef}>

            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              sx={{ m: 4 }}
              size="small"
              color="success"
              onClick={() => { allSubtitlesUpload(true) }}
            >
              آپلود همه زیرنویس ها با کاور
            </Button>

            <Button
              variant="contained"
              startIcon={<PostAddIcon />}
              sx={{ m: 4 }}
              size="small"
              color="warning"
              onClick={() => { resetValueForm() }}
            >
              پاک کردن فرم
            </Button>
            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              sx={{ m: 4 }}
              size="small"
              color="success"
              onClick={() => { allSubtitlesUpload(false) }}
            >
              آپلود همه زیرنویس ها
            </Button>
          </Box>
        </Paper>
      </Box>
    </Grid>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
